import React from 'react';
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import { BUGSNAG_KEY, STAGE } from 'env';

 Bugsnag.start({
    apiKey: BUGSNAG_KEY,
    enabledReleaseStages: ['production', 'staging' ],
    releaseStage: STAGE,
    plugins:[
        new BugsnagPluginReact()
    ]
});

const ErrorBoundary = Bugsnag.getPlugin('react')?.createErrorBoundary(React) || React.Fragment;;

export default ErrorBoundary;

export const getBugsnagClient = () => Bugsnag;
